export const DEVICE_TYPE_LAYOUT = {
  1: [
    {
      name: "Tracker",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 12,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  2: [
    {
      name: "Air Quality",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 4,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 4,
        },
        {
          name: "CO2",
          field: "co2",
          width: 4,
        },
      ],
      avatar: "IAQ",
      showBattery: true,
      isTracker: false,
    },
  ],
  3: [
    {
      name: "Temp & Humidity",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 6,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 6,
        },
      ],
      avatar: "TH",
      showBattery: true,
      isTracker: false,
    },
  ],
  4: [
    {
      name: "Tracker with Button",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 10,
        },
        {
          name: "Alarm",
          field: "sos_event",
          width: 2,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  5: [
    {
      name: "Distance",
      fields: [
        {
          name: "Distance",
          field: "distance",
          width: 12,
        },
      ],
      avatar: "DST",
      showBattery: true,
      isTracker: false,
    },
  ],
  6: [
    {
      name: "Motion with Temp",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 6,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 6,
        },
      ],
      avatar: "MTN",
      showBattery: true,
      isTracker: false,
    },
  ],
  7: [
    {
      name: "Tracker with Temperature",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 3,
        },
        {
          name: "Location",
          field: "geocode",
          width: 9,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  8: [
    {
      name: "Pax Counter",
      fields: [
        {
          name: "Total",
          field: "count",
          width: 4,
        },
        {
          name: "BLE",
          field: "ble",
          width: 4,
        },
        {
          name: "WiFi",
          field: "wifi",
          width: 4,
        },
      ],
      avatar: "PAX",
      showBattery: true,
      isTracker: false,
    },
  ],
  9: [
    {
      name: "Dual Temperature",
      fields: [
        {
          name: "Temperature 1",
          field: "temperature_1",
          width: 6,
        },
        {
          name: "Temperature 2",
          field: "temperature_2",
          width: 6,
        },
      ],
      avatar: "TMP",
      showBattery: true,
      isTracker: false,
    },
  ],
  10: [
    {
      name: "Motion with Count",
      fields: [
        {
          name: "Motion",
          field: "motion",
          width: 4,
        },
        {
          name: "Time",
          field: "time",
          width: 4,
        },
        {
          name: "Count",
          field: "count",
          width: 4,
        },
      ],
      avatar: "MTN",
      showBattery: true,
      isTracker: false,
    },
  ],
  11: [
    {
      name: "Door/Window Sensor",
      fields: [
        {
          name: "Open",
          field: "door_open",
          width: 4,
        },
        {
          name: "Count",
          field: "count",
          width: 4,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 4,
        },
      ],
      avatar: "DWS",
      showBattery: true,
      isTracker: false,
    },
  ],
  12: [
    {
      name: "Water Leak Sensor",
      fields: [
        {
          name: "Leak",
          field: "water_leak",
          width: 4,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 4,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 4,
        },
      ],
      avatar: "WTL",
      showBattery: true,
      isTracker: false,
    },
  ],
  13: [
    {
      name: "Air Quality Advanced",
      fields: [
        {
          name: "TVOC",
          field: "tvoc",
          width: 4,
        },
        {
          name: "CO2",
          field: "co2",
          width: 4,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 2,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 2,
        },
      ],
      avatar: "IAQ",
      showBattery: true,
      isTracker: false,
    },
  ],
  14: [
    {
      name: "Pet Tracker",
      fields: [
        {
          name: "Lost",
          field: "isLost",
          width: 3,
        },
        {
          name: "Location",
          field: "geocode",
          width: 9,
        },
      ],
      avatar: "PET",
      showBattery: true,
      isTracker: true,
    },
  ],
  15: [
    {
      name: "Oyster3",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 12,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  // Device types 15 and 16 are intentionally configured identically with Oyster3 configuration.
  16: [
    {
      name: "Oyster3",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 12,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  17: [
    {
      name: "Cayenne LLP",
      fields: [
        {
          name: "Cayenne LLP",
          field: "data",
          width: 12,
        },
      ],
      avatar: "CLM",
      showBattery: true,
      isTracker: false,
    },
  ],
  18: [
    {
      name: "Tektelic Vivid",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 4,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 4,
        },
        {
          name: "CO2",
          field: "co2",
          width: 4,
        },
      ],
      avatar: "TEK",
      showBattery: false,
      isTracker: false,
    },
  ],
  19: [
    {
      name: "Sensecore Kraken",
      fields: [
        {
          name: "Has Flow",
          field: "HasFlowRate",
          width: 3,
        },
        {
          name: "Current Flow",
          field: "instantaneousFlow",
          width: 3,
        },
        {
          name: "Current Velocity",
          field: "instantaneousVelocity",
          width: 3,
        },
        {
          name: "Total Usage",
          field: "positiveCumulative",
          width: 3,
        },
      ],
      avatar: "FLW",
      showBattery: false,
      isTracker: false,
    },
  ],
  20: [
    {
      name: "Distance Sensor 2",
      fields: [
        {
          name: "Distance",
          field: "distance",
          width: 4,
        },
        {
          name: "Rssi",
          field: "rssi",
          width: 3,
        },
        {
          name: "Hotspot Name",
          field: "hotspot_name",
          width: 5,
        },
      ],
      avatar: "DST",
      showBattery: true,
      isTracker: false,
    },
  ],
  21: [
    {
      name: "Power Meter",
      fields: [
        {
          name: "Current",
          field: "current",
          width: 4,
        },
        {
          name: "Voltage",
          field: "voltage",
          width: 4,
        },
        {
          name: "Watts",
          field: "watt",
          width: 4,
        },
      ],
      avatar: "PWR",
      showBattery: true,
      isTracker: false,
    },
  ],
  22: [
    {
      name: "Leak Sensor",
      fields: [
        {
          name: "Leak",
          field: "leak",
          width: 12,
        },
      ],
      avatar: "WL",
      showBattery: true,
      isTracker: false,
    },
  ],
  23: [
    {
      name: "Advanced Air Quality",
      fields: [
        {
          name: "Temperature",
          field: "temp",
          width: 2,
        },
        {
          name: "Humidity",
          field: "RH",
          width: 2,
        },
        {
          name: "CO2",
          field: "CO2",
          width: 2,
        },
        {
          name: "TVOC",
          field: "TVOC",
          width: 2,
        },
        {
          name: "PM2.5",
          field: "PM2_5",
          width: 2,
        },
        {
          name: "AQI",
          field: "AQI",
          width: 2,
        },
      ],
      avatar: "IAQ",
      showBattery: false,
      isTracker: false,
    },
  ],
  24: [
    {
      name: "Temperature Humidity Sensor",
      fields: [
        {
          name: "Temperature",
          field: "temp",
          width: 6,
        },
        {
          name: "Humidity",
          field: "RH",
          width: 6,
        },
      ],
      avatar: "TH",
      showBattery: true,
      isTracker: false,
    },
  ],
  25: [
    {
      name: "Contact Sensor",
      fields: [
        {
          name: "Contact",
          field: "state",
          width: 12,
        },
      ],
      avatar: "CON",
      showBattery: true,
      isTracker: false,
    },
  ],
  26: [
    {
      name: "Motion Distance Sensor",
      fields: [
        {
          name: "Motion",
          field: "state",
          width: 6,
        },
        {
          name: "Distance",
          field: "distance",
          width: 6,
        },
      ],
      avatar: "MTN",
      showBattery: true,
      isTracker: false,
    },
  ],
  27: [
    {
      name: "Min Max Avg Sensor",
      fields: [
        {
          name: "Min",
          field: "min",
          width: 4,
        },
        {
          name: "Max",
          field: "max",
          width: 4,
        },
        {
          name: "Avg",
          field: "avg",
          width: 4,
        },
      ],
      avatar: "MMA",
      showBattery: false,
      isTracker: false,
    },
  ],
  28: [
    {
      name: "Water Meter",
      fields: [
        {
          name: "Ambient Temperature",
          field: "ambient_temp",
          width: 4,
        },
        {
          name: "Leak",
          field: "leak_status",
          width: 4,
        },
        {
          name: "Total Volume",
          field: "total_volume",
          width: 4,
        },
      ],
      avatar: "WTR",
      showBattery: false,
      isTracker: false,
    },
  ],
  29: [
    {
      name: "4-Button Controller",
      fields: [
        {
          name: "Button 1",
          field: "B1",
          width: 3,
        },
        {
          name: "Button 2",
          field: "B2",
          width: 3,
        },
        {
          name: "Button 3",
          field: "B3",
          width: 3,
        },
        {
          name: "Button 4",
          field: "B4",
          width: 3,
        },
      ],
      avatar: "BTN",
      showBattery: true,
      isTracker: false,
    },
  ],
  30: [
    {
      name: "Multi-Temperature Sensor",
      fields: [
        {
          name: "Temp Red",
          field: "temp_red",
          width: 4,
        },
        {
          name: "Temp Black",
          field: "temp_black",
          width: 4,
        },
        {
          name: "Temp White",
          field: "temp_white",
          width: 4,
        },
      ],
      avatar: "TMP",
      showBattery: true,
      isTracker: false,
    },
  ],
  31: [
    {
      name: "Temperature Humidity",
      fields: [
        {
          name: "Temperature",
          field: "temp",
          width: 6,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 6,
        },
      ],
      avatar: "TH",
      showBattery: true,
      isTracker: false,
    },
  ],
  32: [
    {
      name: "Door Sensor",
      fields: [
        {
          name: "Open",
          field: "door_open",
          width: 6,
        },
        {
          name: "Count",
          field: "count",
          width: 6,
        },
      ],
      avatar: "DWS",
      showBattery: true,
      isTracker: false,
    },
  ],
  33: [
    {
      name: "Environmental Sensor",
      fields: [
        {
          name: "Temperature",
          field: "temp",
          width: 2,
        },
        {
          name: "Humidity",
          field: "rh",
          width: 2,
        },
        {
          name: "CO2",
          field: "co2",
          width: 2,
        },
        {
          name: "PM1",
          field: "mass_conc_pm1_0",
          width: 2,
        },
        {
          name: "PM2.5",
          field: "mass_conc_pm2_5",
          width: 2,
        },
        {
          name: "PM10",
          field: "mass_conc_pm10",
          width: 2,
        },
      ],
      avatar: "IAQ",
      showBattery: false,
      isTracker: false,
    },
  ],
  34: [
    {
      name: "Soil Sensor",
      fields: [
        {
          name: "Temperature",
          field: "soil_temperature",
          width: 4,
        },
        {
          name: "Moisture",
          field: "soil_moisture",
          width: 4,
        },
        {
          name: "Conductivity",
          field: "soil_conductivity",
          width: 4,
        },
      ],
      avatar: "SOIL",
      showBattery: true,
      isTracker: false,
    },
  ],
  35: [
    {
      name: "Soil PH Sensor",
      fields: [
        {
          name: "PH",
          field: "soil_ph",
          width: 6,
        },
        {
          name: "Temperature",
          field: "soil_temperature",
          width: 6,
        },
      ],
      avatar: "PH",
      showBattery: true,
      isTracker: false,
    },
  ],
  36: [
    {
      name: "Leaf Sensor",
      fields: [
        {
          name: "Leaf Moisture",
          field: "leaf_moisture",
          width: 6,
        },
        {
          name: "Leaf Temperature",
          field: "leaf_temperature",
          width: 6,
        },
      ],
      avatar: "LFS",
      showBattery: true,
      isTracker: false,
    },
  ],
  37: [
    {
      name: "Temperature Sensor",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 12,
        },
      ],
      avatar: "TMP",
      showBattery: true,
      isTracker: false,
    },
  ],
  38: [
    {
      name: "Temperature Humidity",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 6,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 6,
        },
      ],
      avatar: "TH",
      showBattery: true,
      isTracker: false,
    },
  ],
  39: [
    {
      name: "Current Meter",
      fields: [
        {
          name: "Amp Hours",
          field: "amp_hour_accumulation",
          width: 2,
        },
        {
          name: "Avg Amps",
          field: "uaverage_amps",
          width: 2,
        },
        {
          name: "Max Amps",
          field: "maximum_amps",
          width: 2,
        },
        {
          name: "Min Amps",
          field: "minimum_amps",
          width: 2,
        },
        {
          name: "Cap Voltage",
          field: "capacitor_voltage",
          width: 2,
        },
        {
          name: "Temperature",
          field: "temperature_celsius",
          width: 2,
        },
      ],
      avatar: "CUR",
      showBattery: false,
      isTracker: false,
    },
  ],
  40: [
    {
      name: "Gas Pressure Sensor",
      fields: [
        {
          name: "Gas Pressure",
          field: "gas_pressure_psi",
          width: 6,
        },
        {
          name: "Transducer mA",
          field: "idc_input_ma",
          width: 6,
        },
      ],
      avatar: "GAS",
      showBattery: true,
      isTracker: false,
    },
  ],
  41: [
    {
      name: "Vehicle Tracker",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 8,
        },
        {
          name: "Ignition",
          field: "ignition",
          width: 4,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  42: [
    {
      name: "Dual Door Sensor",
      fields: [
        {
          name: "Door 1",
          field: "door_open",
          width: 6,
        },
        {
          name: "Door 2",
          field: "door_open2",
          width: 6,
        },
      ],
      avatar: "DWS",
      showBattery: true,
      isTracker: false,
    },
  ],
  43: [
    {
      name: "Smart Plug",
      fields: [
        {
          name: "Plug State",
          field: "plug_state",
          width: 4,
        },
        {
          name: "Power",
          field: "instantaneous_active_power",
          width: 4,
        },
        {
          name: "Power Factor",
          field: "instantaneous_power_factor",
          width: 4,
        },
      ],
      avatar: "PLG",
      showBattery: false,
      isTracker: false,
    },
  ],
  44: [
    {
      name: "Bolt2 Tracker",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 12,
        },
      ],
      avatar: "TRK",
      showBattery: false,
      isTracker: true,
    },
  ],
  45: [
    {
      name: "IAQ Sensor",
      fields: [
        {
          name: "Temperature",
          field: "temp",
          width: 3,
        },
        {
          name: "Humidity",
          field: "RH",
          width: 3,
        },
        {
          name: "CO2",
          field: "CO2",
          width: 3,
        },
        {
          name: "AQI",
          field: "AQI",
          width: 3,
        },
      ],
      avatar: "IAQ",
      showBattery: false,
      isTracker: false,
    },
  ],
  46: [
    {
      name: "Door Sensor with Timer",
      fields: [
        {
          name: "Door Open",
          field: "door_open",
          width: 4,
        },
        {
          name: "Count",
          field: "count",
          width: 4,
        },
        {
          name: "Time",
          field: "time",
          width: 4,
        },
      ],
      avatar: "DWS",
      showBattery: true,
      isTracker: false,
    },
  ],
  47: [
    {
      name: "Door Temp Sensor",
      fields: [
        {
          name: "Door Open",
          field: "door_open",
          width: 4,
        },
        {
          name: "Count",
          field: "count",
          width: 4,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 4,
        },
      ],
      avatar: "DWS",
      showBattery: true,
      isTracker: false,
    },
  ],
  48: [
    {
      name: "Energy Monitor",
      fields: [
        {
          name: "Energy",
          field: "energy",
          width: 3,
        },
        {
          name: "Current",
          field: "current",
          width: 3,
        },
        {
          name: "Watts",
          field: "watts",
          width: 3,
        },
        {
          name: "Power Factor",
          field: "pf",
          width: 3,
        },
      ],
      avatar: "ERG",
      showBattery: false,
      isTracker: false,
    },
  ],
  49: [
    {
      name: "5-in-1 Sensor",
      fields: [
        {
          name: "Mold Risk",
          field: "mold_index",
          width: 3,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 3,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 3,
        },
        {
          name: "CO2",
          field: "co2",
          width: 3,
        },
      ],
      avatar: "5in1",
      showBattery: true,
      isTracker: false,
    },
  ],
  50: [
    {
      name: "Moisture Temperature",
      fields: [
        {
          name: "Moisture",
          field: "moisture",
          width: 6,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 6,
        },
      ],
      avatar: "MOT",
      showBattery: true,
      isTracker: false,
    },
  ],
  51: [
    {
      name: "GPS Temperature",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 8,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 4,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  52: [
    {
      name: "Oyster3 Fusion",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 12,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  53: [
    {
      name: "T1000 Event",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 8,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 2,
        },
        {
          name: "Light",
          field: "light",
          width: 2,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  54: [
    {
      name: "RAK2560",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 2,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 2,
        },
        { name: "Pressure", field: "pressure", width: 2 },
        { name: "Wind Speed", field: "wind_speed", width: 3 },
        { name: "Wind Direction", field: "wind_direction", width: 3 },
      ],
      avatar: "WTR",
      showBattery: false,
      isTracker: false,
    },
  ],
  55: [
    {
      name: "BusTrack IAQ",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 12,
        },
      ],
      avatar: "IAQ",
      showBattery: false,
      isTracker: false,
    },
  ],
  56: [
    {
      name: "OysterFusionWithDoor",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 12,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  57: [
    {
      name: "DraginoLWL03a",
      fields: [
        {
          name: "Water Leak",
          field: "water_leak",
          width: 6,
        },
        {
          name: "Leak Times",
          field: "water_leak_times",
          width: 3,
        },
        {
          name: "Last Leak Duration",
          field: "last_water_leak_duration",
          width: 3,
        },
      ],
      avatar: "WL",
      showBattery: false,
      isTracker: false,
    },
  ],
  58: [
    {
      name: "T1000 Package",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 8,
        },
        {
          name: "Package Status",
          field: "package_opened",
          width: 4,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  59: [
    {
      name: "Dragino lsn50v2_s31b",
      fields: [
        {
          name: "Temperature",
          field: "temperature",
          width: 6,
        },
        {
          name: "Humidity",
          field: "humidity",
          width: 6,
        },
      ],
      avatar: "TH",
      showBattery: true,
      isTracker: false,
    },
  ],
  60: [
    {
      name: "Dragino DDS75",
      fields: [
        {
          name: "Distance",
          field: "distance",
          width: 6,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 6,
        },
      ],
      avatar: "DST",
      showBattery: true,
      isTracker: false,
    },
  ],
  61: [
    {
      name: "Seeed S2120",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 8,
        },
        {
          name: "Weather",
          field: "weather",
          width: 4,
        },
      ],
      avatar: "WTH",
      showBattery: true,
      isTracker: false,
    },
  ],
  62: [
    {
      name: "WeIOT WiMass",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 8,
        },
        {
          name: "Temperature",
          field: "temperature",
          width: 4,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  63: [
    {
      name: "Milesight EM400-TLD",
      fields: [
        {
          name: "Distance",
          field: "distance",
          width: 12,
        },
      ],
      avatar: "DST",
      showBattery: true,
      isTracker: false,
    },
  ],
  64: [
    {
      name: "Milesight EM400-TLD NB-IoT",
      fields: [
        {
          name: "Location",
          field: "geocode",
          width: 8,
        },
        {
          name: "Distance",
          field: "distance",
          width: 4,
        },
      ],
      avatar: "TRK",
      showBattery: true,
      isTracker: true,
    },
  ],
  65: [
    {
      name: "Dragino LWL02",
      fields: [
        {
          name: "Water Leak",
          field: "water_leak",
          width: 6,
        },
        {
          name: "Leak Times",
          field: "water_leak_times",
          width: 3,
        },
        {
          name: "Last Leak Duration",
          field: "last_water_leak_duration",
          width: 3,
        },
      ],
      avatar: "WL",
      showBattery: true,
      isTracker: false,
    },
  ],
  66: [
    {
      name: "Dragino LHT65N-VIB",
      fields: [
        {
          name: "Vibration Count",
          field: "vib_count",
          width: 4,
        },
        {
          name: "Work Min",
          field: "work_min",
          width: 4,
        },
        {
          name: "Alarm",
          field: "alarm",
          width: 4,
        },
      ],
      avatar: "VIB",
      showBattery: true,
      isTracker: false,
    },
  ],
  67: [
    {
      name: "Dragino SE02-LB Soil Sensor",
      fields: [
        {
          name: "Soil Temp 1",
          field: "temp_SOIL",
          width: 2,
        },
        {
          name: "Soil Moisture 1",
          field: "water_SOIL",
          width: 4,
        },
        {
          name: "Soil Temp 2",
          field: "temp_SOIL2",
          width: 2,
        },
        {
          name: "Soil Moisture 2",
          field: "water_SOIL2",
          width: 4,
        },
      ],
      avatar: "SOIL",
      showBattery: true,
      isTracker: false,
    },
  ],
  68: [
    {
      name: "Dragino LSN50v2-D20",
      fields: [
        {
          name: "Temperature",
          field: "TempC_SHT",
          width: 6,
        },
        {
          name: "Humidity",
          field: "Hum_SHT",
          width: 6,
        },
      ],
      avatar: "TH",
      showBattery: true,
      isTracker: false,
    },
  ],
  69: [
    {
      name: "Dragino LSN50v2-D22",
      fields: [
        {
          name: "Temperature 1",
          field: "TempC1",
          width: 6,
        },
        {
          name: "Temperature 2",
          field: "TempC2",
          width: 6,
        },
      ],
      avatar: "TMP",
      showBattery: true,
      isTracker: false,
    },
  ],
  70: [
    {
      name: "Anchuan AC107",
      fields: [
        {
          name: "Device Status",
          field: "device_status",
          width: 6,
        },
        {
          name: "Temperature",
          field: "temperature_c",
          width: 3,
        },
        {
          name: "Humidity",
          field: "humidity_percent",
          width: 3,
        },
      ],
      avatar: "SMK",
      showBattery: true,
      isTracker: false,
    },
  ],
  71: [
    {
      name: "Dragino CPL03",
      fields: [
        {
          name: "Pin Status",
          field: "pin_status",
          width: 4,
        },
        {
          name: "Total Pulses",
          field: "total_pulses",
          width: 4,
        },
        {
          name: "Last Duration",
          field: "last_duration",
          width: 4,
        },
      ],
      avatar: "CT",
      showBattery: true,
      isTracker: false,
    },
  ],
};
